import React from 'react';
import { clsx } from 'clsx';

export function Input({ className, type = "text", ...props }) {
  return (
    <input
      type={type}
      className={clsx(
        "flex h-10 w-full rounded-md bg-[#151415] text-slate-100 px-3 py-2 text-sm placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 focus:ring-offset-slate-900 disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    />
  );
}